<template>
  <div class="top-nav" :style="{ 'padding-left': this.$store.state.core.menuWidth, transition: 'all 0.3s ease' }">
    <div class="site-title">
      <!-- <span>{{ headtitle }}</span> -->
      <Breadcrumb style="font-size: 20px">
        <BreadcrumbItem v-for="(item, index) in headtitle2" :key="index" :to="item.path">
          <!-- <Tooltip content="右击全屏打开新窗口" placement="top-start" :transfer='true'> -->
          <span :title="'Ctrl+点击鼠标左键全屏打开模块'" @click.ctrl="openWindow(item.path)">{{ item.title }}</span>
          <!-- </Tooltip> -->
        </BreadcrumbItem>
      </Breadcrumb>
      <!-- {{ headtitle2 }} -->
      <!-- <Breadcrumb>
        <BreadcrumbItem >Home</BreadcrumbItem>
        <BreadcrumbItem>Components</BreadcrumbItem>
    </Breadcrumb> -->
      <core-globalsearch class="site-input" style="width: 251px"></core-globalsearch>
    </div>
    <!-- 消息提示 -->
    <core-remind style="margin-right: 30px" />
    <!-- 消息提示 -->
    <div class="top-menu">
      <core-userprofile />
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isShow: false, // 显示消息框
      newsNum: 0, // 用于保存子组件传过来的数据
    }
  },
  components: {},
  // inject: ["setmoduleTitle",],moduleTitle
  inject: ["getmoduleTitle"],
  computed: {
    headtitle() {
      // return this.$parent.$parent.moduleTitle;
      return this.getmoduleTitle(this.$route)
    },
    headtitle2() {
      let obj = {}
      let _currentRoutename = this.$route.name
      let _lastRouteInMenuArr = JSON.parse(window.sessionStorage.getItem("lastRouteInMenu")) || []
      let _lastRouteNotInMenuArr = JSON.parse(window.sessionStorage.getItem("lastRouteNotInMenu")) || []

      //把菜单类路由和非菜单类,经行前后合并
      let arr = [..._lastRouteInMenuArr, ..._lastRouteNotInMenuArr]

      if (this.headtitle) arr[arr.length - 1].title = this.headtitle

      if (arr.some((p) => p.name == this.$route.name)) {
        return arr
      } else return [{ title: this.headtitle }]
    },
  },
  watch: {
    $route(to, from) {
      this.setStorage(to)
    },
  },
  created() {
    this.setStorage(this.$route)
  },
  mounted() {},
  methods: {
    // lastRouteInMenu 系统菜单路由
    // lastRouteNotInMenu 非系统菜单路由
    setStorage(router) {
      let _router = router
      var storage = window.sessionStorage
      let obj = {}
      obj.title = this.getmoduleTitle(_router)
      obj.name = _router.name
      obj.path = _router.path
      let isSideBar = this.$app.menus.some((p) => p.name == obj.name)

      //每一种清空都需要重新计算【lastRouteInMenu】【lastRouteNotInMenu】
      if (isSideBar) {
        if (obj.name == "core-modulesNav") {
          // 菜单 router.name 是相同的 所以这步是找出准确的 菜单名称
          let ModulesNav = this.$app.menus.filter((p) => p.children)
          let index = parseInt(router.params.index)
          obj.title = ModulesNav[index].text
        }
        storage.setItem("lastRouteInMenu", JSON.stringify([obj]))
        storage.setItem("lastRouteNotInMenu", JSON.stringify([]))
      } else {
        let parentObj = this.findRootMenu(obj)
        if (parentObj) {
          let arr = [parentObj, obj]
          storage.setItem("lastRouteInMenu", JSON.stringify(arr))
          storage.setItem("lastRouteNotInMenu", JSON.stringify([]))
        } else {
          storage.setItem("lastRouteNotInMenu", JSON.stringify([obj]))
        }
      }
    },
    // 找出所属菜单
    findRootMenu(obj) {
      let arr = []
      let parentObj = {} // 所在菜单
      let ModulesNav = this.$app.menus.filter((p) => p.children)

      for (const [index, item] of ModulesNav.entries()) {
        for (const [index2, item2] of item.children.entries()) {
          if (item2.children) {
            if (item2.children.some((p) => p.name == obj.name)) {
              parentObj.name = item.name
              parentObj.title = item.text
              parentObj.path = `/${item.name}${index}`
              return parentObj
            }
          } else {
            if (item2.name == obj.name) {
              parentObj.name = item.name
              parentObj.path = `/${item.name}${index}`
              parentObj.title = item.text
              return parentObj
            }
          }
        }
      }
      return null
    },

    openWindow(path) {
      let uri = new URL(window.location)
      //【uri.hash】可用这句话来构造：this.$router.resolve({name:"core-userManager",query:{"ff":"ggggg"},params:{}}).href
      uri.hash = `#${path}`
      uri.searchParams.set("fullscreen", "")
      window.open(uri.href, "_blank")
      // let { hash, origin, pathname } = window.location;
      // let url = origin + pathname + "?fullscreen#" + path;
      // window.open(url, "_blank");
      // window.open(url, "_blank","menubar=no","scrollbars=yes");
      // window.open(url,'资金计划项超支提醒','width='+ (window.screen.availWidth-10)+',height='+(window.screen.availHeight-30)+ ',top=0,left=0,resizable=yes,status=yes,menubar=no,scrollbars=yes');
    },
  },
}
</script>
<style lang="scss" scoped>
.top-nav {
  height: 100%;
  // background: #414954;
  display: flex;
  flex-direction: row;
  align-items: center;
  -moz-user-select: none;
  /* Firefox私有属性 */
  -webkit-user-select: none;
  /* WebKit内核私有属性 */
  -ms-user-select: none;
  /* IE私有属性(IE10及以后) */
  -khtml-user-select: none;
  /* KHTML内核私有属性 */
  -o-user-select: none;
  /* Opera私有属性 */
  user-select: none;
  /* CSS3属性 */
}

.site-title {
  display: flex;
  font-size: 20px;
  font-weight: bold;
  justify-content: space-between;
  margin-left: 20px;
  flex: 1;
}

.site-input {
  margin-right: 35px;
}

.top-menu {
  margin-right: 30px;
}
</style>
